import { createContext, type RefObject } from "react";

export type DialogScrollState = {
  hasOverflow: boolean;
  isAtTop: boolean;
  isAtBottom: boolean;
};

export const FullPageDialogContext = createContext<
  | {
      page?: number;
      setPage: (page: number) => void;
      onDismiss?: () => void;
      active: boolean;
      fullHeight: boolean;
      scrollToTop?: () => void;
      scrollContainerRef: RefObject<HTMLDivElement | null>;
      scrollState: DialogScrollState;
      setScrollState: (state: DialogScrollState) => void;
    }
  | undefined
>(undefined);
